import api from './api';

export default {
  clientCheck() {
    return api.post(`/checks/client`);
  }
};
